import { useNavigate } from "react-router-dom";
import { PlusCircle, CheckSquare } from "lucide-react";

export default function PointsCard({ points }) {
  const navigate = useNavigate();
  const currentPoints = points || 0;

  // Funcție pentru a determina nivelul și progresul
  const getLevelData = (pts) => {
    if (pts < 1000) return { name: "SIMPATIZANT", min: 0, max: 1000 };
    if (pts < 5000) return { name: "MEMBRU ACTIV", min: 1000, max: 5000 };
    if (pts < 20000) return { name: "LIDER COMUNITAR", min: 5000, max: 20000 };
    if (pts < 50000) return { name: "ARHITECT AL SCHIMBĂRII", min: 20000, max: 50000 };
    return { name: "VIZIONAR PRDP", min: 50000, max: 100000 };
  };

  const level = getLevelData(currentPoints);
  
  // Calculăm procentajul pentru cercul de progres
  let progress = ((currentPoints - level.min) / (level.max - level.min)) * 100;
  if (progress > 100) progress = 100;
  if (progress < 0) progress = 0;

  // Setările matematice pentru SVG-ul circular
  const circleRadius = 54;
  const circumference = 2 * Math.PI * circleRadius;
  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div 
      style={{ 
        backgroundColor: "#1e293b", // Slate 800
        border: "1px solid rgba(255, 255, 255, 0.05)",
        borderRadius: "20px", 
        padding: "24px", 
        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)", 
        textAlign: "center", 
        height: "100%", 
        display: "flex", 
        flexDirection: "column" 
      }}
    >
      {/* Zona Superioară - Progres și Nivel */}
      <div 
        style={{ 
          backgroundColor: "#0f172a", // Slate 900
          borderRadius: "16px", 
          padding: "30px 20px", 
          marginBottom: "20px", 
          border: "1px solid rgba(255, 255, 255, 0.05)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }}
      >
        {/* Badge Nivel */}
        <div 
          style={{
            border: "1px solid rgba(251, 191, 36, 0.4)",
            borderRadius: "50px",
            padding: "6px 20px",
            color: "#fbbf24", // Galben premium
            fontSize: "0.75rem",
            fontWeight: 700,
            letterSpacing: "1px",
            marginBottom: "24px",
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            boxShadow: "0 0 15px rgba(251, 191, 36, 0.05)"
          }}
        >
          <span>✦</span> NIVEL: {level.name} <span>✦</span>
        </div>

        {/* Inel de Progres Circular */}
        <div style={{ position: "relative", width: "180px", height: "180px" }}>
          <svg width="180" height="180" viewBox="0 0 120 120" style={{ transform: "rotate(-90deg)" }}>
            {/* Cercul de fundal (Track) */}
            <circle
              cx="60"
              cy="60"
              r={circleRadius}
              fill="none"
              stroke="rgba(255, 255, 255, 0.05)"
              strokeWidth="6"
            />
            {/* Cercul de progres animat */}
            <circle
              cx="60"
              cy="60"
              r={circleRadius}
              fill="none"
              stroke="#fbbf24"
              strokeWidth="6"
              strokeDasharray={circumference}
              strokeDashoffset={strokeDashoffset}
              strokeLinecap="round"
              style={{ transition: "stroke-dashoffset 1.5s ease-out" }}
            />
          </svg>

          {/* Conținutul din centrul cercului */}
          <div 
            style={{
              position: "absolute",
              top: 0, left: 0, right: 0, bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <div style={{ fontSize: "2.25rem", fontWeight: 800, color: "#fbbf24", lineHeight: 1.1, letterSpacing: "-1px" }}>
              {currentPoints.toLocaleString('ro-RO')}
            </div>
            <div style={{ color: "#94a3b8", fontSize: "0.7rem", marginTop: "4px", textTransform: "uppercase", letterSpacing: "1.5px", fontWeight: 600 }}>
              Puncte PRDP
            </div>
          </div>
        </div>
      </div>

      <h3 style={{ color: "#f8fafc", fontSize: "1.25rem", fontWeight: 700, marginBottom: "8px" }}>
        Punctajul tău
      </h3>
      <p style={{ color: "#94a3b8", fontSize: "0.95rem", marginBottom: "24px", flexGrow: 1 }}>
        Continuă să participi activ pentru a atinge următorul nivel!
      </p>

      {/* Butoane */}
      <button
        onClick={() => navigate("/propune-proiect")}
        style={{ 
          backgroundColor: "#fbbf24", 
          color: "#0f172a", 
          border: "none", 
          borderRadius: "12px", 
          padding: "12px", 
          fontWeight: 700, 
          fontSize: "0.95rem", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          gap: "8px", 
          marginBottom: "12px", 
          transition: "all 0.2s ease",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f59e0b"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#fbbf24"}
      >
        <PlusCircle size={18} strokeWidth={2.5} /> Propune un proiect
      </button>

      <button 
        onClick={() => navigate("/proiecte")}
        style={{ 
          backgroundColor: "rgba(255, 255, 255, 0.05)", 
          color: "#f8fafc", 
          border: "1px solid rgba(255, 255, 255, 0.1)", 
          borderRadius: "12px", 
          padding: "12px", 
          fontWeight: 600, 
          fontSize: "0.95rem", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          gap: "8px", 
          transition: "all 0.2s ease",
          cursor: "pointer"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.1)"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)"}
      >
        <CheckSquare size={18} color="#fbbf24" /> Votare proiecte
      </button>
    </div>
  );
}
